import $ from 'jquery';

$(function () {
    let $expanding = $('#expanding');

    if ($expanding.length) {
        let $height = $expanding.outerHeight();

        if ($height > 400) {
            $expanding.addClass('small');
            $expanding.after('<div class="expand-button">Expand full agenda</div>');

            $('.expand-button').on('click', function(){
                $expanding.toggleClass('small');

                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                } else {
                    $(this).addClass('open');
                    $(this).html('Close full agenda');
                }
                

            })
        }        

        // for (let i = 0; i < $halfWidthBlocks.length; i++) {
        //     let $block = $($halfWidthBlocks[i]);
        //     let xOffsets = {
        //         left: $block.offset().left,
        //         right: $(window).width() - ($block.offset().left + $block.outerWidth(true))
        //     };

        //     if (xOffsets.left == 0) {
        //         $block.addClass('side-left');
        //     } else if (xOffsets.right == 0) {
        //         $block.addClass('side-right');
        //     }
        // }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/components/ExpandDiv.js